/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * 0 = Left
 * 1 = LeftLarge
 * 2 = Top
 * 3 = TopLarge
 */
export enum ImageStyles {
    '_0' = 0,
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
}
